<script lang="ts">
    import {ValueEditorSize} from '../../../types';
    import {createEventDispatcher} from 'svelte';
    import KpDropdownListbox from '../../../../ui-widgets/dropdown-listbox/KpDropdownListbox.svelte';
    import DropdownListboxAriaLabelledbyProvider from '../../../../ui-widgets/dropdown-listbox/DropdownListboxAriaLabelledbyProvider.svelte';
    import UIcon from 'shared/ui-widgets/uicons/UIcon.svelte';
    import {assertIsString} from 'shared/utils/string-utils';

    export let selectboxOptions: string[] = [];
    export let selected: string;
    export let disabled: boolean;
    export let size: ValueEditorSize = ValueEditorSize.MD;
    export let ariaLabelledby: string;

    const dispatch = createEventDispatcher<{ change: string }>();

    function onChange(event: CustomEvent<string | number>) {
        dispatch('change', asString(event.detail));
    }

    function asString(value: string | number): string {
        assertIsString(value);
        return value;
    }
</script>

<KpDropdownListbox value={selected}
                   options={selectboxOptions}
                   additionalContainerClass="select-box"
                   additionalButtonClass="listbox-toggle-btn"
                   on:change={onChange}
                   {size}
                   {disabled}>

    <svelte:fragment slot="label">
        <DropdownListboxAriaLabelledbyProvider labelId={ariaLabelledby}/>
    </svelte:fragment>

    <svelte:fragment slot="button">
        <span class="listbox-match-text">
            <slot name="button"/>
        </span>

        <UIcon icon="angle-small-down"/>
    </svelte:fragment>

    <svelte:fragment slot="option" let:option>
        <span>
            <slot name="option" option={asString(option)}/>
        </span>
    </svelte:fragment>
</KpDropdownListbox>

<style lang="less" global>
    @import (reference) "bootstrap-less/bootstrap/variables";
    @import (reference) "bootstrap-less/bootstrap/mixins";
    @import (reference) "bootstrap-less/bootstrap/forms";
    @import (reference) "styles/partials/xs-inputs";

    .listbox-toggle-btn.input-lg {
        .input-lg();
    }

    .listbox-toggle-btn.input-sm {
        .input-sm();
    }

    .listbox-toggle-btn.input-xs {
        .input-xs();
    }

    .input-group-btn {
        .listbox-toggle-btn {
            z-index: 2;
            position: relative;
        }

        &:first-child .listbox-toggle-btn {
            .border-right-radius(0);
            margin-right: -1px;
        }

        &:last-child .listbox-toggle-btn {
            .border-left-radius(0);
            margin-left: -1px;
        }
    }

    .listbox-match-text {
        width: 100%;
        padding-right: 10px;
    }
</style>